import { ConnectorStats } from '../leaflet-map.types';
import { getIndicatorColor } from './getIndicatorColor';

export const createLgChargerIndicator = (params: ConnectorStats) => {
    const bgColor = getIndicatorColor(params);

    const html = `<div style="display: flex; align-items: center; justify-content: center; width: 12px; height: 12px; border-radius: 50%; background: #fff; box-shadow: 0px 1px 4px rgba(12, 12, 13, 0.1);">
    <div style="width: 10px; height: 10px; border-radius: 50%; background: ${bgColor};"></div>
</div>`;

    return html;
};
